import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M9.375 3.958 7.292 5.833l2.083 1.875m1.25 8.334 2.083-1.875-2.083-1.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M8.125 5.833h2.917a5 5 0 0 1 5 5v.209m-4.167 3.125H8.958a5 5 0 0 1-5-5v-.209" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);